import React from 'react';
import { Form, FormField, FormProps } from '@gik/ui/Form';
import ShippingFormSchema from './ShippingFormSchema';
import { FormApi, SubmissionErrors } from 'final-form';
import { ShippingDetails } from '@gik/checkout/types';

export interface ShippingFormProps extends FormProps {
  onBeforeSubmit?: (
    values: object,
    form: FormApi<object, object>
  ) => void | SubmissionErrors | Promise<SubmissionErrors>;
}

export default function ShippingForm({
  initialValues,
  onSubmit,
  onBeforeSubmit,
  ...otherProps
}: ShippingFormProps): React.ReactElement {
  async function handleSubmit(values: ShippingDetails, form: FormApi<object, object>): Promise<void> {
    if (onBeforeSubmit) onBeforeSubmit(values, form);
    if (onSubmit) onSubmit(values, form);
  }

  return (
    <Form
      onSubmit={handleSubmit}
      schema={ShippingFormSchema(undefined, true, true)}
      initialValues={initialValues}
      vertical
      validateOnBlur={false}
      {...otherProps}
      render={() => {
        return (
          <>
            <section>
              <FormField name="firstName" className="tw-flex-1" />
              <FormField name="lastName" className="tw-flex-1" />
            </section>
            <FormField name="email" />
            <FormField name="companyName" />
            <FormField name="country" />
            <FormField name="address1" />
            <FormField name="address2" />
            <section>
              <FormField name="city" className="tw-flex-1" />
              <FormField name="state" />
              <FormField name="postalCode" />
            </section>
          </>
        );
      }}
    />
  );
}
